import React, { useEffect, useRef, useState } from "react";
import "./Orders.css";
import { Container, Col, Row } from "react-bootstrap";
import { SearchFilter } from "../../components/SearchFilter/SearchFilter";

import { GetOrderList } from "../../apis/OrderAPI";
import { Link } from "react-router-dom";
import { GetOrderStatus } from "../../apis/MiscAPI";
import dateFormat from "dateformat";
import { useSelector } from "react-redux";

export default function Orders() {
  const {user} = useSelector((state) => state.auth);
  const [customerOrderData, setCustomerOrderData] = useState([]);
  const [orderStatuses, setOrderStatuses] = useState([]);
  const [visible, setVisible] = useState(9);
  const [totalRecord, setTotalRecord] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [showLoadMore, setShowLoadMore] = useState(true);
  const [isSearchedData, setIsSearchedData] = useState(false);
  const [sortingField, setSortingField] = useState("order_id");
  const [sortingOrder, setSortingOrder] = useState("desc");
  const [isSorting, setIsSorting] = useState(false);

  const searchBody = useRef();
  const loadMoreData = () => {
    setVisible((prevValue) => prevValue + 9);
  };

  async function GetOrderData(oldlist) {
    let body = searchBody.current;
    var result = await GetOrderList(body);
    var data = result.data;
    if (oldlist.length > 0 && !isSorting) {
      let list = JSON.parse(JSON.stringify(oldlist));
      list.push(...data);
      setCustomerOrderData(list);
    } else setCustomerOrderData(data);
    if (data.length > 0) setTotalRecord(data[0].totalRows);
  }

  async function GetOrderStatuses() {
    var result = await GetOrderStatus();
    setOrderStatuses(result.data);
  }

  useEffect(() => {
    GetOrderStatuses();
  }, []);

  useEffect(() => {
    var pgSize = 9;
    var pgCount = pageCount;
    if (isSorting) {
      pgSize = pageCount * 9;
      pgCount = 1;
    }
    if (!isSearchedData) {
      searchBody.current = {
        pageNo: pgCount + "",
        pageSize: pgSize + "",
        requestor_id: user.requestorid,
        sortingField: sortingField,
        sortingOrder: sortingOrder,
      };
    } else searchBody.current.pageNo = pageCount + "";
    if (pageCount === 1) GetOrderData([]);
    else GetOrderData(customerOrderData);
  }, [pageCount, sortingField, sortingOrder]);

  useEffect(() => {
    if (visible < totalRecord) {
      setShowLoadMore(true);
    } else setShowLoadMore(false);
    if (visible / 9 > pageCount) setPageCount((prevValue) => prevValue + 1);
  }, [visible, totalRecord]);

  //

  const handleSearch = async (searchValue) => {
    setPageCount(1);
    setIsSorting(false);
    searchValue === "" ? setIsSearchedData(false) : setIsSearchedData(true);
    searchBody.current = {
      order_id: searchValue,
      pageNo: "1",
      pageSize: "9",
      requestor_id: user.requestorid,
      sortingField: sortingField,
      sortingOrder: sortingOrder,
    };
    if (pageCount === 1) await GetOrderData([]);
  };

  const handleAdvanceSearch = async (searchData) => {
    setPageCount(1);
    setIsSearchedData(true);
    setIsSorting(false);
    let submissionSearch = false;
    let completionSearch = false;
    if (
      searchData.submissionStartDate !== "" &&
      searchData.submissionEndDate !== ""
    )
      submissionSearch = true;
    if (
      searchData.completionStartDate !== "" &&
      searchData.completionEndDate !== ""
    )
      completionSearch = true;

    let doSearch = false;

    if (
      submissionSearch ||
      completionSearch ||
      (searchData.applicantName != null && searchData.applicantName !== "") ||
      searchData.orderStatus.statusId !== 0
    )
      doSearch = true;

    if (doSearch) {
      searchBody.current = {
        requestor_id: user.requestorid,
        submission_start_date:
          submissionSearch === true
            ? dateFormat(searchData.submissionStartDate, "yyyy-mm-dd")
            : "",
        submission_end_date:
          submissionSearch === true
            ? dateFormat(searchData.submissionEndDate, "yyyy-mm-dd")
            : "",
        completion_start_date:
          completionSearch === true
            ? dateFormat(searchData.completionStartDate, "yyyy-mm-dd")
            : "",
        completion_end_date:
          completionSearch === true
            ? dateFormat(searchData.completionEndDate, "yyyy-mm-dd")
            : "",
        applicant_name: searchData.applicantName,
        status:
          searchData.orderStatus.statusId === 0
            ? ""
            : searchData.orderStatus.statusId + "",
        pageNo: "1",
        pageSize: "9",
        sortingField: sortingField,
        sortingOrder: sortingOrder,
      };
    }

    if (pageCount === 1) await GetOrderData([]);
  };

  const handleSorting = (sorting) => {
    var sortingField = sorting.value;
    setIsSorting(true);
    if (sortingField !== "") {
      let sort = sortingField.split(" ");
      setSortingField(sort[0]);
      setSortingOrder(sort[1]);
    } else {
      setSortingField("order_id");
      setSortingOrder("desc");
    }
  };

  return (
    <>
      <Container>
        <Row className="page-head-row">
          <Col lg={6} md={6} sm={12}>
            <div className="page-title">
              <h2>Orders</h2>
            </div>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <div className="search-filter">
              <SearchFilter
                search={handleSearch}
                orderStatuses={orderStatuses}
                requestorid={user.requestorid}
                investigatorid="0"
                advSearch={handleAdvanceSearch}
                displayShort={true}
                shortFields={[
                  { text: "Order ID ↑ ", value: "order_id asc" },
                  { text: "Order ID ↓ ", value: "order_id desc" },
                  { text: "Order Date ↑", value: "order_start_date asc" },
                  { text: "Order Date ↓", value: "order_start_date desc" },
                  { text: "Applicant ↑", value: "order_applicant_name asc" },
                  { text: "Applicant ↓", value: "order_applicant_name desc" },
                  { text: "Order Status ↑", value: "order_status_name asc" },
                  { text: "Order Status ↓", value: "order_status_name desc" },
                ]}
                sortOrder={handleSorting}
              />
            </div>
          </Col>
        </Row>
        <Row className="order-row">
          {customerOrderData.length !== 0 ? (
            customerOrderData.slice(0, visible).map((orderlist) => (
              <Col xl={4} lg={4} md={6} sm={12} key={orderlist.id}>
                <div className="cards">
                  <div className="cards-head">
                    <div className="cards-title h5">
                      OrderNo: {orderlist.id}
                    </div>
                  </div>
                  <div className="cards-body">
                    <div className="cards-text">
                      <div className="cards-list-group">
                        <div className="cards-list-item">
                          <span>Date: </span>
                          {orderlist.orderStartDate}
                        </div>
                        <div className="cards-list-item">
                          <span>Applicant: </span>
                          {orderlist.orderApplicantName}
                        </div>
                        <div className="cards-list-item">
                          <span>Status: </span>
                          {orderlist.orderStatusName}
                        </div>
                      </div>
                    </div>
                  </div>
                  <Link
                    className="cards-link"
                    to={"/Customer/OrdersDetails?id=" + orderlist.id}
                  >
                    View Order
                  </Link>
                </div>
              </Col>
            ))
          ) : (
            <p>No results found</p>
          )}
        </Row>
        <div
          className={
            showLoadMore ? "text-center my-5" : "text-center my-5 hide-div"
          }
        >
          <button onClick={loadMoreData} className="btn-load-more">
            Load More...
          </button>
        </div>
      </Container>
    </>
  );
}
